import React from "react";
import withRouter from "../../custom/withRouter";
import { connect } from "react-redux";
import "bootstrap";
import { toast } from "react-toastify";
import UserRole from "../../helpers/role";
import UserStatus from "../../helpers/status";
import formats from "../../helpers/MediaFormats";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { PulseLoader } from "react-spinners";
import $ from "jquery";
import axios from "axios";
import CommonIcon from "../../helpers/icons";
import FileIcon from "../../helpers/FileIcon";
import WarningComponent from "../../helpers/modal";
import Toaster from "../../helpers/toaster";
import PaginationComponent from "../../helpers/Pagination";
import API from "../../helpers/endpointservice";
import DateFnsUtils from "@date-io/date-fns";
import Select from "react-select";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { logoutFunction } from "../../custom/logoutFunction";
import swal from "sweetalert";

const styles = {
  placeholder: (provided) => ({
    ...provided,
    whiteSpace: "noWrap",
    textOverflow: "ellipsis",
  }),
};

class Training extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "desc",
      sortBy: "trainingRequestId",
      isSortAscending: true,
      currentUser: "",
      isRequestFailed: false,
      isRequestLoader: false,
      height: window.innerHeight,
      isTab: false,
      isMobile: false,
      isRadioMobile: false,
      isSmallMobile: false,
      iswebMobile: false,
      pageCount: 20,
      action: "",
      userId: 0,
      trainingStatus: "",
      trainingcertificateId: 0,
      trainingtrainingBondId: 0,
      trainingtrainingBond: "",
      trainingcertificate: "",
      teamtrainingList: [],
      teamtrainingView: {},
      versionLogList: [],
      currentPage: 1,
      perPage: 20,
      totalCount: 0,
      requestCount: 0,
      historyLogList: [],
      approvedocumentsList: [],

      rows: [
        {
          id: 1,
          question: "",
          grade: "",
        },
      ],
      employeeNameEmpty: false,
      selectEmployeeName: [],
      employeeNameList: [],
      searchInputData: {
        trainingRequestId: "",
        employeeCode: "",
        employeeName: "",
        courseCode: "",
        courseTitle: "",
        requestedDate: null,
        startDate: null,
        endDate: null,
        currentStatus: "",
        designation: "",
        requestedBy: "",
        email: "",
        mobileNumber: "",
        trainingBondStatus: "",
        certificateStatus: "",
        louStatus: "",
        courseQuestionnaireStatus: "",
        pteStatus: "",
      },
      isSearch: false,
      validationMsg: false,
      pageNewCount: false,
      isView: true,
      isLou: false,
      isPte: false,
      isCourse: false,
      PTE: [],
      pteAnswersOption: [],
      pteJobAnswerOption: [],
      pteJob: [],
      courseAdd: [],
      CourseQuestAnswers: [],
      LouDetails: {},
      LouAnswers: {},
      currentStatusList: [],
      currentStatus: [],
      louStatus: [],
      louStatusList: [],
      trainingBondStatus: [],
      trainingBondstatusList: [],
      pteStatus: [],
      pteStatusList: [],
      certificateStatus: [],
      certificateStatusList: [],
      courseQuestionnaireStatus: [],
      cqStatusList: [],
    };
  }

  componentDidMount() {
    let userRole = localStorage.getItem("Role").split(",")[0];
    let userId = localStorage.getItem("UserId");
    this.state.userRole = userRole;
    this.state.userId = userId;
    this.state.currentUser = userRole;
    $(document).on("click", function (event) {
      const newLocal = "#propertiesScreen";
      if ($("#propertiesScreen").hasClass("show")) {
        var $trigger = $(newLocal);
        if ($trigger !== event.target && !$trigger.has(event.target).length) {
          $("#propertiesScreen").removeClass("show");
          $("body").removeClass("scrollhide");
        }
      }
    });
    $("body").removeClass("scrollhide");
    const intervals = setInterval(() => {
      this.resize();
    }, 10);
    this.teamTrainingList(this.state.currentPage, this.state.perPage);
    this.getCourseQuestAnswers();
    this.getPteAnswerOptions();
    this.getPteJobAnswerOptions();
    this.getCurrentStatus();
  }

  getCurrentStatus = () => {
    let apiUrl = `${API.GET_CURRENT_STATUS}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.currentStatusList = res?.data?.currentStatus?.map(
            (status) => {
              return {
                value: status,
                label: (
                  <>
                    <span>{status}</span>
                  </>
                ),
              };
            }
          );

          this.state.louStatusList = res?.data?.lou?.map((status) => {
            return {
              value: status,
              label: (
                <>
                  <span>{status}</span>
                </>
              ),
            };
          });

          this.state.trainingBondstatusList = res?.data?.trainingBond?.map(
            (status) => {
              return {
                value: status,
                label: (
                  <>
                    <span>{status}</span>
                  </>
                ),
              };
            }
          );

          this.state.cqStatusList = res?.data?.courseQuestionnaire?.map(
            (status) => {
              return {
                value: status,
                label: (
                  <>
                    <span>{status}</span>
                  </>
                ),
              };
            }
          );

          this.state.pteStatusList = res?.data?.pte?.map((status) => {
            return {
              value: status,
              label: (
                <>
                  <span>{status}</span>
                </>
              ),
            };
          });

          this.state.certificateStatusList = res?.data?.certificate?.map(
            (status) => {
              return {
                value: status,
                label: (
                  <>
                    <span>{status}</span>
                  </>
                ),
              };
            }
          );
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isTrainingLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  fetchPaginationList = (currentpage, perpage) => {
    this.setState(
      {
        currentPage: currentpage,
        perPage: perpage,
        isSortAscending: this.state.isSortAscending,
        sortBy: this.state.sortBy,
      },
      () => {
        this.teamTrainingList(currentpage, perpage);
      }
    );
  };

  teamTrainingList = (currentPage, perPage) => {
    const { userId, searchInputData, isSearch } = this.state;
    this.state.isRequestLoader = true;
    let order = this.state.order === "asc" ? true : false;
    let apiUrl = `${API.GET_TEAM_TRAINING}?sortBy=${this.state.sortBy
      }&isSortAscending=${order}&UserId=${userId}&pageNumber=${parseInt(
        currentPage
      )}&pageSize=${parseInt(perPage)}`;
    let searchValues = {
      trainingRequestId: searchInputData.trainingRequestId || null,
      employeeCode: searchInputData.employeeCode || null,
      employeeName: searchInputData.employeeName || null,
      courseCode: searchInputData.courseCode || null,
      courseTitle: searchInputData.courseTitle || null,
      currentStatus: searchInputData.currentStatus || null,
      requestedDate:
        searchInputData.requestedDate?.toISOString()?.slice(0, 10) || null,
      designation: null,
      requestedBy: null,
      email: null,
      mobileNumber: null,
      trainingBondStatus: searchInputData.trainingBondStatus || null,
      certificateStatus: searchInputData.certificateStatus || null,
      louStatus: searchInputData.louStatus || null,
      courseQuestionnaireStatus:
        searchInputData.courseQuestionnaireStatus || null,
      pteStatus: searchInputData.pteStatus || null,
      startDate: searchInputData.startDate?.toISOString()?.slice(0, 10) || null,
      endDate: searchInputData.endDate?.toISOString()?.slice(0, 10) || null,
    };
    axios({
      method: "POST",
      url: apiUrl,
      data: isSearch === true ? searchValues : {},
    })
      .then((res) => {
        if (res.status === 200) {
          this.setState({
            teamtrainingList: res.data.values,
            totalCount: res.data.totalCount,
            isRequestLoader: false,
          });
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isSearch: false, isRequestLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  resize = () => {
    if (window.innerWidth < 1280) {
      this.state.isTab = true;
    } else {
      this.state.isTab = false;
    }
    if (window.innerWidth < 850) {
      this.setState({ isMobile: true });
    } else {
      this.setState({ isMobile: false });
    }
    if (window.innerWidth < 750) {
      this.setState({ isSmallMobile: true });
    } else {
      this.setState({ isSmallMobile: false });
    }
    if (window.innerWidth < 490) {
      this.setState({ isRadioMobile: true });
    } else {
      this.setState({ isRadioMobile: false });
    }
    if (window.innerWidth < 400) {
      this.setState({ iswebMobile: true });
    } else {
      this.setState({ iswebMobile: false });
    }
    this.setState({ height: window.innerHeight });
  };

  getCourseQuestAnswers = () => {
    // let apiurl = `${API.GET_COURSE_QUEST_ANSWERS}`;
    axios.get(API.GET_COURSE_QUEST_ANSWERS).then((res) => {
      if (res.status === 200) {
        const evaluationAns = res.data?.map((item) => ({
          id: item.id,
          name: item.name,
        }));

        this.state.CourseQuestAnswers = evaluationAns;
        this.setState({});
      }
    });
  };

  getPteAnswerOptions = () => {
    // let apiurl = `${API.GET_COURSE_QUEST_ANSWERS}`;
    axios.get(API.GET_EVAL_ANS).then((res) => {
      if (res.status === 200) {
        const pteEvaluationAns = res.data?.map((item) => ({
          id: item.id,
          name: item.name,
        }));
        this.state.pteAnswersOption = pteEvaluationAns;
        this.setState({});
      }
    });
  };

  getPteJobAnswerOptions = () => {
    // let apiurl = `${API.GET_COURSE_QUEST_ANSWERS}`;
    axios.get(API.GET_SKILL_STATUS).then((res) => {
      if (res.status === 200) {
        const pteJobEvaluationAns = res.data?.map((item) => ({
          id: item.id,
          name: item.name,
        }));
        this.state.pteJobAnswerOption = pteJobEvaluationAns;
        this.setState({});
      }
    });
  };

  getCourseQuestionnaireById = (id) => {
    let apiUrl = `${API.GET_COURSE_QUESTIONAIRE}?trainingRequestId=${id}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.editWarning = false;
          this.state.courseAdd = res.data.questions;
          this.setState({});
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isRequestLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  getLouById = (id) => {
    let apiUrl = `${API.GET_PENDING_LOU}?trainingRequestId=${id}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.LouDetails = res.data;
          this.state.isRequestLoader = false;
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isRequestLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  getPteById = (id) => {
    let apiUrl = `${API.GET_PTE_BY_ID}?trainingRequestId=${id}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.PTE = res.data.pteQuestions;
          this.state.pteJob = res.data.jobQuestions;
          this.setState({});
        }
      })
      .catch((error) => {
        logoutFunction(error?.response?.status);
        console.log(error);
        this.setState({ isRequestLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  MyRequestDetails = (Id, status) => {
    this.state.isRequestLoader = true;
    this.state.trainingStatus = status;
    this.setState({});
    this.getTrainingHistoryList(Id);
    this.getTrainingDataList(Id);
    let apiUrl = `${API.GET_TEAM_TRAINING_BY_ID}?requestId=${Id}`;
    // axios({
    //   method: "GET",
    //   url: apiUrl,
    // })
    //   .then((res) => {
    //     if (res.status === 200) {
    //       this.state.teamtrainingView = res.data;
    //       this.setState({});
    //     }
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //     logoutFunction(error?.response?.status);
    //     this.setState({ isRequestLoader: false });
    //     swal("Error!", "Something went wrong. Please try again.", "warning");
    //   });
    this.setState({
      isView: true,
      isLou: false,
      isCourse: false,
      isPte: false,
    });
    // let myOffcanvas = new window.bootstrap.Offcanvas(
    //   document.getElementById("propertiesScreen")
    // );
    // myOffcanvas.show();
    // $("body").addClass("scrollhide");
  };

  getTrainingHistoryList = (id) => {
    this.setState({});
    let apiUrl = `${API.GET_TEAM_TRAINING_HISTORY}?trainingRequestId=${id}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          // this.state.isRequestLoader = false;
          this.state.historyLogList = res.data;
          this.setState({});
        }
      })
      .catch((error) => {
        console.log(error);
        logoutFunction(error?.response?.status);
        // this.setState({ isRequestLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  sortTable = (name) => {
    let sortData = this.state.pendingApprovalsList;
    if (sortData?.length !== 0) {
      if (this.state.sortBy === name) {
        this.state.sortBy = name;
        if (this.state.order === "asc") {
          var ordernew = "desc";
          this.state.order = ordernew;
        } else {
          var ordernew = "asc";
          this.state.order = ordernew;
        }
      } else {
        this.state.sortBy = name;
        this.state.order = "asc";
      }
      this.state.currentPage = 1;
      this.state.pageNewCount = !this.state.pageNewCount;
      this.setState({}, () => {
        this.teamTrainingList(this.state.currentPage, this.state.perPage);
      });
    }
  };

  getTrainingDataList = (id) => {
    let apiUrl = `${API.GET_MYTRAININGID}?requestId=${id}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.teamtrainingView = res.data;
          let value = res.data;
          if (res.data?.isPte === true) {
            const pendingStatusPte = res.data?.pteStatus
              ?.toLowerCase()
              ?.replace(/\s+/g, "");
            if (
              //     pendingStatusPte === UserStatus.PTE2_UPDATE ||
              //     pendingStatusPte === UserStatus.PTE3_UPDATE ||
              //     pendingStatusPte === UserStatus.PTE1_REWORK ||
              //     pendingStatusPte === UserStatus.PTE2_REWORK ||
              //     pendingStatusPte === UserStatus.PTE3_REWORK ||
              //     pendingStatusPte === UserStatus.PENDING_FOR_PTE1_ACKNOWLEDGE ||
              //     pendingStatusPte === UserStatus.PENDING_FOR_PTE2_ACKNOWLEDGE ||
              //     pendingStatusPte === UserStatus.PENDING_FOR_PTE3_ACKNOWLEDGE ||
              //     pendingStatusPte === UserStatus.PENDING_FOR_PTE1_APPROVAL ||
              //     pendingStatusPte === UserStatus.PENDING_FOR_PTE2_APPROVAL ||
              //     pendingStatusPte === UserStatus.PENDING_FOR_PTE3_APPROVAL ||
              //     pendingStatusPte === UserStatus.PTE1_UPDATED ||
              //     pendingStatusPte === UserStatus.PTE2_UPDATED ||
              //     pendingStatusPte === UserStatus.PTE3_UPDATED ||
              //     pendingStatusPte === UserStatus.WAITING_FOR_PTE2 ||
              //     pendingStatusPte === UserStatus.WAITING_FOR_PTE3 ||
              //     pendingStatusPte === UserStatus.PTE_COMPLETED
              !pendingStatusPte?.includes(UserStatus.PTE1_UPDATE)
            ) {
              this.getPteById(id);
            } else {
              this.state.PTE = [];
              this.setState({});
            }
          }

          if (res.data?.isLou === true) {
            if (res.data.louStatus?.toLowerCase() === UserStatus.SUBMITTED) {
              this.getLouById(id);
            } else {
              this.state.LouDetails = [];
              this.setState({});
            }
          }

          if (res.data?.isCourseQuestionnaire === true) {
            if (
              res.data.courseQuestionnaireStatus?.toLowerCase() ===
              UserStatus.PENDING_FOR_CQ_REVIEW ||
              res.data.courseQuestionnaireStatus?.toLowerCase() ===
              UserStatus.COMPLETED_STATUS
            ) {
              this.getCourseQuestionnaireById(id);
            } else {
              this.state.courseAdd = [];
              this.setState({});
            }
          }

          this.state.teamtrainingView = value;
          this.state.trainingtrainingBondId = value.trainingBond?.fileId;
          this.state.trainingtrainingBond = value.trainingBond?.fileName;
          this.state.trainingcertificateId = value.certificate?.fileId;
          this.state.trainingcertificate = value.certificate?.fileName;
          this.setState({});
          this.state.isRequestLoader = false;
          let myOffcanvas = new window.bootstrap.Offcanvas(
            document.getElementById("propertiesScreen")
          );
          myOffcanvas.show();
          $("body").addClass("scrollhide");
        }
      })
      .catch((error) => {
        console.log(error);
        logoutFunction(error?.response?.status);
        this.setState({ isRequestLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };

  handleFileOpen = (id, type) => {
    if (id) {
      let fileUrl = null;
      const fetchFileUrl = async () => {
        let fileSrcUrl = `${API.GET_FILES_URL}?fileId=${id}`;
        await axios
          .get(fileSrcUrl)
          .then((response) => {
            if (response?.status === 200) {
              fileUrl = response.data;
              if (fileUrl) {
                const fileType =
                  type === "url" ? type : fileUrl.split(".").pop();
                const supportedFormats = Object.values(formats).flat();

                if (supportedFormats.includes(fileType)) {
                  const findKeyByValue = (value, obj) => {
                    for (let key in obj) {
                      if (obj[key].includes(value)) {
                        return key;
                      }
                    }
                    return null;
                  };

                  const fileTypeKey = findKeyByValue(fileType, formats);

                  if (fileTypeKey) {
                    switch (fileTypeKey) {
                      case "video":
                        break;
                      case "audio":
                        break;
                      case "word":
                      case "pdf":
                      case "ppt":
                      case "zip":
                      case "xlsx":
                      case "image":
                      case "url":
                        window.open(fileUrl);
                        break;
                      default:
                        console.error(`Unsupported file type: ${fileType}`);
                    }
                    return;
                  } else {
                    console.error(`Unsupported file type: ${fileType}`);
                  }
                } else {
                  console.error(`Unsupported file type: ${fileType}`);
                }
              }
            }
          })
          .catch((err) => {
            console.log(err);
            logoutFunction(err?.response?.status);
            this.setState({ isRequestLoader: false });
            swal(
              "Error!",
              "Something went wrong. Please try again.",
              "warning"
            );
          });
      };
      fetchFileUrl();
    }
  };

  closeProperties = () => {
    this.setState({
      isPte: false,
      isCourse: false,
      isLou: false,
      isView: true,
      LouDetails: [],
      courseAdd: [],
      PTE: [],
      pteJob: [],
    });
    $("#propertiesScreen").removeClass("show");
    $("body").removeClass("scrollhide");
    this.state.order = "asc";
    this.setState({});
  };

  handleReject = () => {
    let cancelPopup = new window.bootstrap.Modal(
      document.getElementById("RejectScreen")
    );
    cancelPopup.show();
    $("body").addClass("scrollhide");
  };

  handleRequest = (name) => {
    this.setState({ action: name }, () => {
      let cancelPopup = new window.bootstrap.Modal(
        document.getElementById("CancelCourseScreen")
      );
      cancelPopup.show();
      $("body").addClass("scrollhide");
    });
  };

  handleApprove = () => {
    $("#propertiesScreen").removeClass("show");
    $("body").removeClass("scrollhide");
    toast.success("Approved successfully");
  };

  handleSubmit = () => {
    $("#propertiesScreen").removeClass("show");
    $("body").removeClass("scrollhide");
    toast.success("Submitted successfully");
  };

  handleRejectPopup = () => {
    $("#propertiesScreen").removeClass("show");
    $("body").removeClass("scrollhide");
    toast.success("Rejected successfully");
  };

  handleCancelRequestPopup = () => {
    $("#propertiesScreen").removeClass("show");
    $("body").removeClass("scrollhide");
    toast.success("Request cancelled successfully");
  };

  closeReject = () => {
    $("body").removeClass("scrollhide");
  };

  addRow = () => {
    const newRow = {
      id: "",
      question: "",
      grade: "",
    };
    this.setState((prevState) => ({
      rows: [...prevState.rows, newRow],
    }));
  };

  removeRow = (Id) => {
    var array = [...this.state.rows];
    if (array.length === 1) {
    } else {
      if (Id - 1 !== -1) {
        array.splice(Id - 1, 1);
        this.setState({ rows: array });
      }
    }
  };

  closeAddScreen = () => {
    $("#AddScreen").removeClass("show");
    $("body").removeClass("scrollhide");
    this.state.order = "asc";
    this.setState({ rows: [] });
    this.setState({
      rows: [
        {
          id: 1,
          question: "",
          grade: "",
        },
      ],
    });
    this.setState({});
  };

  //Search Screen
  openSearch = () => {
    // let myOffcanvas = new window.bootstrap.Offcanvas(document.getElementById("searchScreen"));
    // myOffcanvas.show();
    this.setState({ validationMsg: false });
    $("#searchScreen").removeClass("display-hide");
    $("#searchScreen").addClass("visible-show");
    $("body").addClass("scrollhide");

    this.getEmployeeName();
  };
  closeSearch = () => {
    $("#searchScreen").addClass("display-hide");
    $("#searchScreen").removeClass("visible-show");
    $("body").removeClass("scrollhide");
    this.state.order = "asc";
  };
  getEmployeeName = () => {
    this.setState({ isTrainingLoader: true });
    const { userId } = this.state;
    let apiUrl = `${API.GET_EMPLOYEES}?userId=${userId}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.employeeNameList = res?.data?.map((employee) => {
            return {
              value: employee.employeeName,
              label: (
                <>
                  <span>{employee.employeeName}</span>
                </>
              ),
            };
          });
          this.setState({
            isRequestLoader: false,
          });
        }
      })
      .catch((err) => {
        console.log(err);
        logoutFunction(err?.response?.status);
        this.setState({ isRequestLoader: false });
        swal("Error!", "Something went wrong. Please try again.", "warning");
      });
  };
  clearAllData = () => {
    this.setState({
      isSearch: false,
      validationMsg: false,
      searchInputData: {
        trainingRequestId: "",
        employeeCode: "",
        employeeName: "",
        courseCode: "",
        courseTitle: "",
        requestedDate: null,
        startDate: null,
        endDate: null,
        currentStatus: "",
        designation: "",
        requestedBy: "",
        email: "",
        mobileNumber: "",
        trainingBondStatus: "",
        certificateStatus: "",
        louStatus: "",
        pteStatus: "",
        courseQuestionnaireStatus: "",
      },
      currentStatus: null,
      trainingBondStatus: null,
      certificateStatus: null,
      louStatus: null,
      courseQuestionnaireStatus: null,
      pteStatus: null,
      employeeNameList: [],
      selectEmployeeName: [],
    });
  };

  clearSearchDetails = () => {
    this.clearAllData();
    this.state.currentPage = 1;
    this.state.pageNewCount = !this.state.pageNewCount;
    this.setState({}, () =>
      this.teamTrainingList(this.state.currentPage, this.state.perPage)
    );
    $("#propertiesScreen").removeClass("show");
    $("#searchScreen").addClass("display-hide");
    $("#searchScreen").removeClass("visible-show");
    $("body").removeClass("scrollhide");
  };

  handleInputchange(e, field) {
    if (
      field === "requestedDate" ||
      field === "startDate" ||
      field === "endDate"
    ) {
      let reqDate = new Date(e);
      this.state.searchInputData[field] = reqDate;
    } else {
      this.state.searchInputData[field] = e.target.value;
    }

    this.setState({});
  }

  onchangeEmployeeName = (e, field) => {
    if (e === null) {
      this.state.searchInputData[field] = "";
      this.state.selectEmployeeName = [];
      this.setState({});
    } else {
      this.state.searchInputData[field] = e.value;
      this.state.selectEmployeeName = e;
      this.setState({});
    }
  };

  validateSearchRecords = () => {
    const inputs = document.querySelectorAll(
      ".records-editinput-class[required]"
    );
    let isValid4 = false;
    if (this.state.searchInputData.currentStatus || this.state.searchInputData.trainingBondStatus
      || this.state.searchInputData.certificateStatus || this.state.searchInputData.louStatus
      || this.state.searchInputData.courseQuestionnaireStatus || this.state.searchInputData.pteStatus
    ) {
      isValid4 = true;
    } else {
      isValid4 = false;
    }
    const isValid = Array?.from(inputs)?.some((input) => input.value !== "");
    const isValid1 =
      this.state.selectEmployeeName?.length !== 0 ||
      this.state.searchInputData.requestedDate ||
      this.state.searchInputData.startDate ||
      this.state.searchInputData.endDate;
    const isValid2 = this.state.searchInputData.startDate;
    const isValid3 = this.state.searchInputData.endDate;
    if (isValid || isValid1 || isValid2 || isValid3 || isValid4) {
      this.submitSearchDetails();
      this.setState({
        validationMsg: false,
      });
    } else {
      this.setState({
        validationMsg: true,
      });
    }
  };

  submitSearchDetails = () => {
    this.state.isSearch = true;
    this.state.currentPage = 1;
    this.state.pageNewCount = !this.state.pageNewCount;
    this.setState({}, () =>
      this.teamTrainingList(this.state.currentPage, this.state.perPage)
    );
    $("#searchScreen").addClass("display-hide");
    $("#searchScreen").removeClass("visible-show");

    $("body").removeClass("scrollhide");
  };
  //End Search Screen

  showViewStatus = () => {
    this.state.isRequestLoader = true;
    setTimeout(() => {
      this.state.isRequestLoader = false;
    }, 1000);
    this.setState({
      isPte: false,
      isLou: false,
      isCourse: false,
      isView: true,
    });
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("propertiesScreen")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
  };

  showLouStatus = () => {
    this.state.isRequestLoader = true;
    setTimeout(() => {
      this.state.isRequestLoader = false;
    }, 1000);
    this.setState({
      isPte: false,
      isLou: true,
      isCourse: false,
      isView: false,
    });
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("propertiesScreen")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
  };

  showPteStatus = () => {
    this.state.isRequestLoader = true;
    setTimeout(() => {
      this.state.isRequestLoader = false;
    }, 1000);
    this.setState({
      isPte: true,
      isLou: false,
      isCourse: false,
      isView: false,
    });
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("propertiesScreen")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
  };

  showCourseStatus = () => {
    this.state.isRequestLoader = true;
    setTimeout(() => {
      this.state.isRequestLoader = false;
    }, 1000);
    this.setState({
      isPte: false,
      isLou: false,
      isCourse: true,
      isView: false,
    });
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("propertiesScreen")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
  };

  handleCurrentStatus = (e) => {
    this.state.currentStatus = e;
    this.state.searchInputData.currentStatus = e?.value ? e.value : "";
    this.setState({});
  };

  onchangeCertificateStatus = (e) => {
    this.state.certificateStatus = e;
    this.state.searchInputData.certificateStatus = e?.value ? e.value : "";
    this.setState({});
  };

  onchangeCqStatus = (e) => {
    this.state.courseQuestionnaireStatus = e;
    this.state.searchInputData.courseQuestionnaireStatus = e?.value
      ? e.value
      : "";
    this.setState({});
  };

  onchangeLouStatus = (e) => {
    this.state.louStatus = e;
    this.state.searchInputData.louStatus = e?.value ? e.value : "";
    this.setState({});
  };

  onchangeTbStatus = (e) => {
    this.state.trainingBondStatus = e;
    this.state.searchInputData.trainingBondStatus = e?.value ? e.value : "";
    this.setState({});
  };

  onchangePteStatus = (e) => {
    this.state.pteStatus = e;
    this.state.searchInputData.pteStatus = e?.value ? e.value : "";
    this.setState({});
  };

  handleTBondComments = (e) => {
    this.setState({
      trainingComments: e.target.value,
    });
  };

  render() {
    const {
      isMobile,
      isTab,
      isRequestFailed,
      isRequestLoader,
      isSmallMobile,
      iswebMobile,
      historyLogList,
      teamtrainingList,
      currentPage,
      pageCount,
      perPage,
      teamtrainingView,
      isRadioMobile,
      currentUser,
      sortBy,
      order,
      isPte,
      isView,
      isCourse,
      isLou,
      LouDetails,
      pteAnswersOption,
      pteJobAnswerOption,
      pteJob,
      PTE,
      courseAdd,
      pendingApprovalsView,
    } = this.state;
    let {
      classes,
      actionCommonSearchResult,
      requestCommonSearchResult,
      menuToggle,
    } = this.props;
    return (
      <>
        <Toaster />
        {$("#propertiesScreen").hasClass("show") ||
          $("#searchScreen").hasClass("visible-show") ? (
          <div className="viewbar-overlay"></div>
        ) : (
          <></>
        )}
        {$("#AddScreen").hasClass("show") ? (
          <div className="viewbar-overlay"></div>
        ) : (
          <></>
        )}

        <div
          className={`${isMobile
            ? "main-body-mobile"
            : menuToggle
              ? "menu-main-body"
              : "main-body"
            } `}
        >
          {isRequestLoader && (
            <div className="spinner_overlay">
              <div className="loader">
                <PulseLoader color="#D12232" size={10} speedMultiplier={1} />
              </div>
            </div>
          )}

          {isRequestFailed && (
            <div className="spinner_overlay">
              <div className="loader">
                <span>Loading failed</span>
              </div>
            </div>
          )}

          {/* {isMobile == true ? (
                        <div className="mobile-head border-bottom w-100">
                            <div className="col-12 mobile-title">
                                {"Team training"}{" "}
                            </div>
                        </div>
                    ) : (
                        <div className="head-fixed">
                            <div className="title">
                                <>
                                    <CommonIcon fileName="teamtrainingActive" />
                                    <span className="pl-10 head-span">
                                        Team training{" "}
                                    </span>
                                </>
                            </div>
                        </div>
                    )} */}

          <>
            {isMobile == true ? (
              <div className={`p-0 mr-0 w-80 `}>
                <span
                  className={`mobile-head border-bottom w-100 d-flex justify-content-between`}
                >
                  <span className="mobile-title">Team trainings</span>
                  <span onClick={() => this.openSearch()}>
                    <CommonIcon fileName="searchIcon1" />
                  </span>
                </span>
              </div>
            ) : (
              // <div className="d-flex w-100 row mobile-head border-bottom pr-0">
              //     <div className="col-10 mobile-title">Team trainings{" "}</div>
              //     <div className="filter-icon col-2 text-align-end" >
              //         <span className="cursor-pointer" onClick={() => this.openSearch()}>
              //             <CommonIcon fileName="filterIcon" /></span>
              //     </div>
              // </div>
              <div className="head-fixed">
                <div
                  className={` ${menuToggle ? "width-100" : "width-filter"
                    } px-4 position-relative border-bottom row `}
                >
                  <div className="col-6 border-none title">
                    <CommonIcon fileName="teamtrainingActive" />
                    <span className="pl-10 head-span">Team trainings </span>
                  </div>
                  <div className="text-align-end  title border-none display text-16-red mt-3px col-6">
                    <span
                      className="text-20-bold pr-30 cursor-pointer"
                      onClick={() => this.openSearch()}
                    >
                      <CommonIcon fileName="filterIcon" />
                    </span>
                  </div>
                </div>
              </div>
            )}
          </>
          {/* <ToastContainer /> */}
          <div
            className={`${isMobile ? "team-mobiletable-style" : "common-pending-style"} table-responsive `}>
            <div className={`${isMobile ? "table-scroll-xy-mobile top-105px" : menuToggle ? "table-scroll-xy-menutoggle" : "table-scroll-xy"} table-list-view-bottom table-fixed-header`} >
              <table className="table fileListTable2 table-borderless table-hover">
                <thead>
                  <tr>
                    <td></td>
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => this.sortTable("trainingRequestId")}
                    >
                      <span> Request ID </span>
                      {sortBy === "trainingRequestId" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => this.sortTable("employeeCode")}
                    >
                      <span>Employee code </span>
                      {sortBy === "employeeCode" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => this.sortTable("employeeName")}
                    >
                      <span>Employee name </span>
                      {sortBy === "employeeName" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => this.sortTable("courseCode")}
                    >
                      <span>Course code </span>
                      {sortBy === "courseCode" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => this.sortTable("courseTitle")}
                    >
                      <span> Course title </span>
                      {sortBy === "courseTitle" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    {(UserRole.ADMIN === currentUser ||
                      UserRole.SUPERVISOR === currentUser ||
                      UserRole.MANAGER === currentUser) && (
                        <td
                          style={{ cursor: "pointer" }}
                          onClick={() => this.sortTable("requestedBy")}
                        >
                          <span> Requested by </span>
                          {sortBy === "requestedBy" && (
                            <CommonIcon
                              fileName={order === "asc" ? "upArrow" : "downArrow"}
                            />
                          )}
                        </td>
                      )}
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => this.sortTable("currentStatus")}
                    >
                      <span> Current status</span>
                      {sortBy === "currentStatus" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => this.sortTable("louStatus")}
                    >
                      <span> LOU status</span>
                      {sortBy === "louStatus" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => this.sortTable("trainingBondStatus")}
                    >
                      <span> Training bond status</span>
                      {sortBy === "trainingBondStatus" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => this.sortTable("pteStatus")}
                    >
                      <span> PTE status</span>
                      {sortBy === "pteStatus" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => this.sortTable("certificateStatus")}
                    >
                      <span> Certificate status</span>
                      {sortBy === "certificateStatus" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        this.sortTable("courseQuestionnaireStatus")
                      }
                    >
                      <span> CQ status</span>
                      {sortBy === "courseQuestionnaireStatus" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => this.sortTable("startDate")}
                    >
                      <span> Start date </span>
                      {sortBy === "startDate" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => this.sortTable("endDate")}
                    >
                      <span> End date </span>
                      {sortBy === "endDate" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                    <td
                      style={{ cursor: "pointer" }}
                      onClick={() => this.sortTable("requestedDate")}
                    >
                      <span> Requested date </span>
                      {sortBy === "requestedDate" && (
                        <CommonIcon
                          fileName={order === "asc" ? "upArrow" : "downArrow"}
                        />
                      )}
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {teamtrainingList?.length !== 0 ? (
                    teamtrainingList.map((item, index) => (
                      <tr
                        id={"active" + item.id}
                        key={index}
                        className="requestRadioSelect"
                      >
                        <td></td>
                        <td
                          onClick={() =>
                            this.MyRequestDetails(item.id, item.currentStatus)
                          }
                        >
                          <span>
                            <a className="properties-view cursor-pointer">
                              {item.trainingRequestId
                                ? item.trainingRequestId
                                : "-"}
                            </a>
                          </span>
                        </td>
                        <td className="width-150px">
                          <span>
                            {item.employeeCode ? item.employeeCode : " -"}{" "}
                          </span>
                        </td>
                        <td className="width-150px">
                          <span>
                            {item.employeeName ? item.employeeName : "-"}{" "}
                          </span>
                        </td>
                        <td className="width-150px">
                          <span>
                            {item.courseCode ? item.courseCode : "-"}{" "}
                          </span>
                        </td>
                        <td className="width-150px">
                          <span>
                            {item.courseTitle ? item.courseTitle : "-"}{" "}
                          </span>
                        </td>
                        {(UserRole.ADMIN === currentUser ||
                          UserRole.SUPERVISOR === currentUser ||
                          UserRole.MANAGER === currentUser) && (
                            <td>
                              <span>{item.requestedBy}</span>
                            </td>
                          )}
                        <td className="width-150px">
                          <span style={{ color: item?.currentStatus?.toLowerCase()?.indexOf("pending") > -1 ? "#c81e2e" : "#000" }}>
                            {item.currentStatus ? item.currentStatus : "-"}
                          </span>
                        </td>
                        <td className="width-150px">
                          <span style={{ color: item?.louStatus?.toLowerCase()?.indexOf("pending") > -1 ? "#c81e2e" : "#000" }}>{item.louStatus ? item.louStatus : "-"}</span>
                        </td>
                        <td className="width-150px">
                          <span style={{ color: item?.trainingBondStatus?.toLowerCase()?.indexOf("pending") > -1 ? "#c81e2e" : "#000" }}>
                            {item.trainingBondStatus
                              ? item.trainingBondStatus
                              : "-"}
                          </span>
                        </td>
                        <td className="width-150px">
                          <span style={{ color: item?.pteStatus?.toLowerCase()?.indexOf("pending") > -1 ? "#c81e2e" : "#000" }}>{item.pteStatus ? item.pteStatus : "-"}</span>
                        </td>
                        <td className="width-150px">
                          <span style={{ color: item?.certificateStatus?.toLowerCase()?.indexOf("pending") > -1 ? "#c81e2e" : "#000" }}>
                            {item.certificateStatus
                              ? item.certificateStatus
                              : "-"}
                          </span>
                        </td>
                        <td className="width-150px">
                          <span style={{ color: item?.courseQuestionnaireStatus?.toLowerCase()?.indexOf("pending") > -1 ? "#c81e2e" : "#000" }}>
                            {item.courseQuestionnaireStatus
                              ? item.courseQuestionnaireStatus
                              : "-"}
                          </span>
                        </td>
                        <td>
                          <span>
                            {item.trainingStartDate
                              ? moment(
                                new Date(Date.parse(item.trainingStartDate))
                              ).format("DD-MMM-YYYY h:mm A")
                              : "-"}
                          </span>
                        </td>
                        <td>
                          <span>
                            {item.trainingEndDate
                              ? moment(
                                new Date(Date.parse(item.trainingEndDate))
                              ).format("DD-MMM-YYYY h:mm A")
                              : "-"}
                          </span>
                        </td>
                        <td>
                          <span>
                            {item.requestedDate
                              ? moment(
                                new Date(Date.parse(item.requestedDate))
                              ).format("DD-MMM-YYYY h:mm A")
                              : "-"}
                          </span>
                        </td>
                        {/* <td className="width-10px"></td> */}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={17} className="table-nodata text-center">
                        {"No record found"}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div
            className={`${isMobile
              ? "common-mobilesubmenu mobile-pagination"
              : menuToggle
                ? "common-submenu sidemenu-pagination"
                : "common-submenu web-pagination"
              } pb-2 pt-2`}
          ></div>
        </div>

        <div
          className={` ${isView
            ? "offcanvasStyle"
            : isLou
              ? "offcanvas-lou mt-48"
              : isCourse
                ? "course_questionnaire_add"
                : isPte
                  ? "pte_add"
                  : ""
            } offcanvas  offcanvas-end  `}
          tabIndex={-1}
          data-bs-scroll="false"
          data-bs-backdrop="false"
          id="propertiesScreen"
          aria-labelledby="offcanvasScrollingLabel"
        >
          <div
            className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3 mt-10"
              }`}
          >
            <h6 id="offcanvasRightLabel" className="modal-title fw-600">
              {this.state.trainingStatus}
            </h6>
            <button
              className={`text-reset offcavasclose buttonstyle ${isMobile ? "pr-0" : ""
                }`}
              style={{ backgroundColor: "white" }}
              onClick={() => this.closeProperties()}
            >
              <CommonIcon
                fileName="CrossIcon"
                className="cursor-pointer app-image-hover"
              />
            </button>
          </div>
          <div className="offcanvas-body px-4 pt-0">
            <div
              className={` d-flex text-12-normal pb-2 justify-content-start min-width-heading  `}
            >
              <div
                className={` ${isView ? "border-bottom-red" : "border-bottom"
                  } pb-2  cursor-pointer no-wrap`}
                onClick={() => {
                  this.showViewStatus();
                }}
              >
                <label className="cursor-pointer">
                  {isView == false && <CommonIcon fileName="MyselfIcon" />}
                  {isView == true && <CommonIcon fileName="mySelfIconActive" />}

                  <span className={` ${isView ? "text-color-red" : ""} px-2`}>
                    Details
                  </span>
                </label>
              </div>
              <div
                className={` ${isLou ? "border-bottom-red" : "border-bottom"
                  } pb-2 cursor-pointer px-2`}
                onClick={() => {
                  this.showLouStatus();
                }}
              // onClick={this.showLou}
              >
                <label className="cursor-pointer">
                  {isLou == true && <CommonIcon fileName="louactiveicon" />}
                  {isLou == false && <CommonIcon fileName="louicon" />}
                  <span className={` ${isLou ? "text-color-red" : ""} px-2`}>
                    LOU
                  </span>
                </label>
              </div>

              <div
                className={` ${isCourse ? "border-bottom-red" : "border-bottom"
                  } cursor-pointer pb-2 cursor-pointer px-2 `}
                onClick={() => {
                  this.showCourseStatus();
                }}
              // onClick={this.showCourseQuestionnaire}
              >
                <label className="cursor-pointer">
                  <lable>
                    {isCourse == true && <CommonIcon fileName="cqActiveIcon" />}
                  </lable>
                  {isCourse == false && (
                    <CommonIcon fileName="CourseQuestionIcon" />
                  )}
                  <span className={` ${isCourse ? "text-color-red" : ""} px-2`}>
                    CQ
                  </span>
                </label>
              </div>
              <div
                className={` ${isPte ? "border-bottom-red" : "border-bottom"
                  }   pb-2 cursor-pointer px-2 `}
                onClick={() => {
                  this.showPteStatus();
                }}
              // onClick={this.showPte}
              >
                <label className="cursor-pointer">
                  {isPte == true && <CommonIcon fileName="pteActive" />}
                  {isPte == false && <CommonIcon fileName="pteIcon" />}
                  <span className={` ${isPte ? "text-color-red" : ""} px-2`}>
                    PTE
                  </span>
                </label>
              </div>
              {
                // isMobile == false &&
                <div
                  className={` ${isView && "min-width-editcourse"} ${isLou && "min-width-courseLou"
                    } ${isCourse && "min-width-courseCq"} ${isPte && "min-width-coursePte"
                    } border-bottom`}
                ></div>
              }
            </div>

            {/* //////////////////// Status view ////////////////////// */}

            {isView && (
              <div>
                <div className="row mt-3">
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      }`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon
                          fileName="RequestIcon"
                          className="properties-img"
                        />
                        <span className="pl-10 properties-span">
                          Request ID
                        </span>
                        &nbsp;
                      </label>
                      <label
                        className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                      >
                        {teamtrainingView.id
                          ? teamtrainingView.trainingRequestId
                          : " - "}
                      </label>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      }`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon
                          fileName="UserIcon"
                          className="properties-img"
                        />
                        <span className="pl-10 properties-span">
                          Employee name
                        </span>
                        &nbsp;
                      </label>
                      <label
                        className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                      >
                        {teamtrainingView.employeeName
                          ? teamtrainingView.employeeName
                          : " - "}
                      </label>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      }`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon
                          fileName="employeecode"
                          className="properties-img"
                        />
                        <span className="pl-10 properties-span">
                          Employee code
                        </span>
                        &nbsp;
                      </label>
                      <label
                        className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                      >
                        {teamtrainingView.employeeCode
                          ? teamtrainingView.employeeCode
                          : " - "}
                      </label>
                    </div>
                  </div>

                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      }`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon
                          fileName="CourseCodeIcon"
                          className="properties-img"
                        />
                        <span className="pl-10 properties-span">
                          Course code
                        </span>
                      </label>
                      <label
                        className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                      >
                        {teamtrainingView.courseCode
                          ? teamtrainingView.courseCode
                          : " - "}
                      </label>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-6 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon
                          fileName="CourseTitleIcon"
                          className="properties-img"
                        />
                        <span className="pl-7 properties-span">
                          Course title
                        </span>
                      </label>
                      <label
                        className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                      >
                        {teamtrainingView.courseTitle
                          ? teamtrainingView.courseTitle
                          : " - "}
                      </label>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      }`}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon
                          fileName="requestedby"
                          className="properties-img"
                        />
                        <span className="pl-7 properties-span">
                          {" "}
                          Requested by{" "}
                        </span>
                      </label>
                      <label
                        className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                      >
                        {teamtrainingView.requestedBy
                          ? teamtrainingView.requestedBy
                          : " - "}
                      </label>
                    </div>
                  </div>

                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon
                          fileName="PropertiesIcon"
                          className="properties-img"
                        />
                        <span className="pl-10 properties-span">
                          Current status
                        </span>
                      </label>
                      <label
                        className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                      >
                        {teamtrainingView.currentStatus
                          ? teamtrainingView.currentStatus
                          : " - "}
                      </label>
                    </div>
                  </div>

                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon
                          fileName="DateIcon"
                          className="properties-img"
                        />
                        <span className="pl-10 properties-span">
                          Start date
                        </span>
                      </label>
                      <label
                        className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                      >
                        {teamtrainingView.trainingStartDate
                          ? moment(teamtrainingView.trainingStartDate).format(
                            "DD-MMM-YYYY HH:MM A"
                          )
                          : " - "}
                      </label>
                    </div>
                  </div>

                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon
                          fileName="DateIcon"
                          className="properties-img"
                        />
                        <span className="pl-10 properties-span">End date</span>
                      </label>
                      <label
                        className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                      >
                        {teamtrainingView.trainingEndDate
                          ? moment(teamtrainingView.trainingEndDate).format(
                            "DD-MMM-YYYY HH:MM A"
                          )
                          : " - "}
                      </label>
                    </div>
                  </div>

                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon
                          fileName="DateIcon"
                          className="properties-img"
                        />
                        <span className="pl-10 properties-span">
                          Requested date
                        </span>
                      </label>
                      <label
                        className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                          }`}
                      >
                        {teamtrainingView.requestedDate
                          ? moment(teamtrainingView.requestedDate).format(
                            "DD-MMM-YYYY HH:MM A"
                          )
                          : " - "}
                      </label>
                    </div>
                  </div>

                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon
                          fileName="trainingbondicon"
                          className="properties-i mg"
                        />
                        <span className="pl-10 properties-span">
                          Training bond
                        </span>
                      </label>
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <a
                          className={`cursor-pointer text-decoration-none url-label-style d-flex ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                            }`}
                          onClick={() =>
                            this.handleFileOpen(
                              this.state.trainingtrainingBondId,
                              "url"
                            )
                          }
                          target="_blank"
                        >
                          <FileIcon
                            fileName={this.state.trainingtrainingBond}
                            className="documentFile"
                          />
                          <span className="pl-7 text-center urlspan">
                            {this.state.trainingtrainingBond
                              ? this.state.trainingtrainingBond
                              : "-"}
                          </span>
                        </a>
                      </label>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon
                          fileName="trainingbondicon"
                          className="properties-i mg"
                        />
                        <span className="pl-10 properties-span">
                          Training bond status
                        </span>
                      </label>
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        {teamtrainingView.trainingBondStatus
                          ? teamtrainingView.trainingBondStatus
                          : "-"}
                      </label>
                    </div>
                  </div>
                  <>
                    <div
                      className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                        } `}
                    >
                      <div className="form-group">
                        <label
                          className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                            }`}
                        >
                          <CommonIcon
                            fileName="trainingbondicon"
                            className="properties-img"
                          />
                          <span className="pl-10 properties-span">
                            Certificate
                          </span>
                        </label>
                        <label
                          className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                            }`}
                        >
                          <a
                            className={`cursor-pointer text-decoration-none url-label-style d-flex ${isSmallMobile ? "mt-3 mb-2" : "mt-2"
                              }`}
                            onClick={() =>
                              this.handleFileOpen(
                                this.state.trainingcertificateId,
                                "url"
                              )
                            }
                            target="_blank"
                          >
                            <FileIcon
                              fileName={this.state.trainingcertificate}
                              className="documentFile"
                            />
                            <span className="pl-7 text-center urlspan">
                              {this.state.trainingcertificate
                                ? this.state.trainingcertificate
                                : "-"}
                            </span>
                          </a>
                        </label>
                      </div>
                    </div>
                  </>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon
                          fileName="certificateCourseCatalogue"
                          className="properties-img"
                        />
                        <span className="pl-10 text-12-bold">
                          Certificate status
                        </span>
                      </label>
                      <div>
                        <span className="label-text">
                          {teamtrainingView.certificateStatus
                            ? teamtrainingView.certificateStatus
                            : "-"}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon
                          fileName="louicon"
                          className="properties-img"
                        />
                        <span className="pl-10 text-12-bold">LOU status</span>
                      </label>
                      <div>
                        <span className="label-text">
                          {teamtrainingView.louStatus
                            ? teamtrainingView.louStatus
                            : "-"}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon
                          fileName="CourseQuestionIcon"
                          className="properties-img"
                        />
                        <span className="pl-10 text-12-bold">CQ status</span>
                      </label>
                      <div>
                        <span className="label-text">
                          {teamtrainingView.courseQuestionnaireStatus
                            ? teamtrainingView.courseQuestionnaireStatus
                            : "-"}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                      } `}
                  >
                    <div className="form-group">
                      <label
                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                          }`}
                      >
                        <CommonIcon
                          fileName="pteIcon"
                          className="properties-img"
                        />
                        <span className="pl-10 text-12-bold">PTE status</span>
                      </label>
                      <div>
                        <span className="label-text">
                          {teamtrainingView.pteStatus
                            ? teamtrainingView.pteStatus
                            : "-"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* /////////////////////////// Lou View /////////////////////// */}

            {isLou && (
              <div className="row mt-3">
                <div className="mt-2 scroll">
                  {LouDetails?.questions?.length > 0 ? (
                    LouDetails?.questions?.map((item, questionIndex) => (
                      <div
                        className="text-12-normal-400 d-flex pb-2"
                        key={questionIndex}
                      >
                        {item?.question?.includes("textbox") ? (
                          <>
                            <div className="fw-bold no-wrap">
                              {questionIndex + 1}
                              {" . "}
                            </div>
                            <p className="pl-5 pr-2 lh-base">
                              {item.question
                                .split("textbox")
                                .map((part, partIndex) => (
                                  <React.Fragment key={partIndex}>
                                    {partIndex > 0 && (
                                      <span className="lou-min-width border-bottom pl-10 pr-10">
                                        {
                                          item?.answer?.split("&*&")[
                                          partIndex - 1
                                          ]
                                        }
                                        {/* <input
                                        className="form-control height-18 remove-border LOUID color-white"
                                        name="louName"
                                        value={item?.answer?.split(",")[partIndex - 1]}
                                        disabled={true}
                                      /> */}
                                      </span>
                                    )}
                                    <>
                                      <span
                                        className="word-css"
                                        dangerouslySetInnerHTML={{
                                          __html: part
                                            ? part.replace(/\n/g, "<br>")
                                            : "",
                                        }}
                                      ></span>
                                    </>
                                  </React.Fragment>
                                ))}
                            </p>
                          </>
                        ) : (
                          <p className="pl-zero pr-2 pt-2 lh-base">
                            <span className="fw-bold no-wrap">
                              {questionIndex + 1}
                              {" . "}
                            </span>
                            <span
                              className=""
                              dangerouslySetInnerHTML={{
                                __html: item.question
                                  ? item.question.replace(/\n/g, "<br>")
                                  : "",
                              }}
                            ></span>
                          </p>
                        )}
                      </div>
                    ))
                  ) : (
                    <>
                      <div className="text-center">
                        <label className="text-16-normal fw-bold text-color-red">
                          {this.state.teamtrainingView.louStatus?.toLowerCase() ===
                            "lou not applicable"
                            ? "LOU is not applicable for this training."
                            : "LOU is not submitted for this training."}
                        </label>
                      </div>
                    </>
                  )}
                  <div>
                    {LouDetails?.questions?.length > 0 && (
                      <>
                        <div className="text-12-normal-400 mt-3">
                          <div className="mt-2">
                            <input
                              type="radio"
                              name="terms"
                              value="1"
                              disabled
                              checked={LouDetails?.isAgree == true}
                            />
                            <span className="mx-3">I agree</span>
                          </div>
                          <div className="mt-2">
                            <input
                              type="radio"
                              name="terms"
                              value="1"
                              disabled
                              checked={LouDetails?.isAgree == false}
                            />
                            <span className="mx-3">I don't agree</span>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}

            {/* ////////////   Course Questionnaire View //////////////// */}

            {isCourse && (
              <div>
                <div className="row ">
                  {this.state.courseAdd?.length > 0 ? (
                    <>
                      <div className={`col-12 pr-10`}>
                        <div
                          className={`${iswebMobile ? "col-12" : "col-12 pl-0"
                            } col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 ${iswebMobile ? "mt-2" : isMobile ? "" : ""
                            } `}
                        ></div>
                      </div>

                      {/* table */}
                      <div className={` mt-2 ${isMobile ? "" : "pb-3"} row  `}>
                        <div
                          className={` table-responsive table-responsive-scroll `}
                        >
                          <table className="course-table-width-course-view ">
                            <>
                              <thead>
                                <tr className="border-top height-course">
                                  <th className="col-1 text-12-bold pt-2 border-right border-left pl-10 pb-20">
                                    <span>S.no</span>
                                  </th>
                                  <th className="col-6 pt-2 text-12-bold cq-box-view border-right border-left pl-10 pb-20">
                                    Question
                                  </th>
                                  <th className="col-5 border-right text-12-bold pt-2 border-left pl-10 pb-20">
                                    Answer
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="border-bottom ">
                                {this.state.courseAdd?.length > 0 ? (
                                  this.state.courseAdd.map((item, index) => (
                                    <>
                                      <tr
                                        key={index}
                                        className={` ${this.state.courseAdd?.length !==
                                          index + 1 && "border-bottom"
                                          } `}
                                      >
                                        <td className="col-1 text-12-bold mt-2 border-right border-left pl-10 pb-80 ">
                                          {index + 1}
                                        </td>
                                        <td className="col-6  cq-box-view mt-2 border-right border-left pl-10 pr-10 pb-20 text-12-normal-400">
                                          <textarea
                                            className={`text-wrap color-white form-text-box2 resize-none border-none border-radius-0 w-100`}
                                            rows="3"
                                            value={item.question}
                                            readOnly={true}
                                            disabled={true}
                                          >
                                            {item.question}
                                          </textarea>
                                        </td>
                                        <td
                                          className={`col-5 mt-2 pl-10 pb-20 text-wrap border-right text-12-normal-400 ${isMobile
                                            ? "form-control-mobile"
                                            : ""
                                            }`}
                                        >
                                          {this.state.CourseQuestAnswers?.map(
                                            (courseOption) => (
                                              <>
                                                <input
                                                  className={`height ${courseOption?.id ===
                                                    item?.answerId &&
                                                    "color-black"
                                                    }`}
                                                  type="radio"
                                                  // name="test"
                                                  disabled={
                                                    courseOption?.id !==
                                                    item?.answerId
                                                  }
                                                  checked={
                                                    courseOption?.id ===
                                                    item?.answerId
                                                  }
                                                />
                                                <label
                                                  className={`${isMobile ? "pl-3" : "pl-10"
                                                    } label-text`}
                                                >
                                                  {courseOption?.name}
                                                </label>
                                                <br />
                                              </>
                                            )
                                          )}
                                        </td>
                                      </tr>
                                    </>
                                  ))
                                ) : (
                                  <tr>
                                    <td className="border-right border-left"></td>
                                    <td
                                      colSpan={7}
                                      className="table-nodata text-center border-right p-2"
                                    >
                                      {"No record found"}
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </>
                          </table>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <>
                        <div className="text-center mt-3">
                          <label className="text-16-normal align-text-middle fw-bold text-color-red">
                            {this.state.teamtrainingView.courseQuestionnaireStatus?.toLowerCase() ===
                              "cq not applicable"
                              ? "CQ is not applicable for this training."
                              : "CQ is not submitted for this training."}
                          </label>
                        </div>
                      </>
                    </>
                  )}
                </div>
              </div>
            )}

            {/* //////////////// PTE VIEW ////////////////// */}

            {isPte && (
              <div>
                <div className="row">
                  {this.state.PTE?.length > 0 ? (
                    <>
                      <div
                        className={`col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 ${iswebMobile ? "mt-2" : isMobile ? "" : ""
                          } `}
                      >
                        <button
                          className={` pte-label-button label-text ${isMobile ? "pt-2" : ""
                            }`}
                        >
                          <CommonIcon fileName="skillKonwIcon" />
                          <span className="pl-5 properties-span-2">
                            Capability and Knowledge Evaluation
                          </span>
                        </button>
                      </div>

                      {/* table */}
                      <div className={` mt-2 ${isMobile ? "" : "pb-3"}`}>
                        <div className={` table-responsive table-responsive-scroll `}>
                          <table className="postskill-table-width">
                            <thead>
                              <tr className="border-top height-course">
                                <th className=" slno text-12-bold border-right border-left pl-5px">
                                  S.no
                                </th>
                                <th className="skill-box text-12-bold border-right border-left pl-5px">
                                  Capability & knowledge
                                </th>
                                <th className="levelofskill text-12-bold border-right border-left pl-5px">
                                  Level of capability and knowledge (Pre-Training)
                                </th>
                                <th className="levelofskill text-12-bold border-left border-right pl-5px">
                                  Level of capability and knowledge (Post-Training)
                                </th>
                                <th className="levelofskill text-12-bold border-left border-right pl-5px">
                                  Level of capability and knowledge (Post-Training-further)
                                </th>
                              </tr>
                            </thead>
                            <tbody className="border-bottom text-12-normal-400">
                              {this.state.PTE?.length > 0 ? (
                                this.state.PTE.map((item, index) => (
                                  <tr key={index + "PTE"} className={`${this.state.PTE?.length !== (index + 1) && "border-bottom"} `}>
                                    <td className=" text-12-bold border-right border-left pl-10 pb-80">
                                      {index + 1}
                                    </td>

                                    <td className="mt-2 border-right border-left pl-10 pr-10 pb-20">
                                      <textarea
                                        className={`text-wrap form-text-box2 resize-none border-radius-0 border-none color-white w-100 `}
                                        rows="3"
                                        value={item.question}
                                        readOnly={true}
                                        disabled={true}
                                      // disabled={true}
                                      >
                                        {item.question}
                                      </textarea>
                                    </td>
                                    <td
                                      className={` pl-10 pb-20 text-wrap border-right ${isMobile ? "form-control-mobile" : ""
                                        }`}
                                    >
                                      {this.state.pteAnswersOption?.map(
                                        (pteOption1) => (
                                          <>
                                            <input
                                              className={`height ${pteOption1?.id ===
                                                item?.ptE1AnswerId &&
                                                "color-black"
                                                }`}
                                              type="radio"
                                              // name={"test" + index}
                                              disabled={
                                                pteOption1?.id !==
                                                item?.ptE1AnswerId
                                              }
                                              checked={
                                                pteOption1?.id ===
                                                item?.ptE1AnswerId
                                              }
                                            />
                                            <label
                                              className={`${isMobile ? "pl-3" : "pl-10"
                                                }`}
                                            >
                                              {pteOption1?.name}
                                            </label>
                                            <br />
                                          </>
                                        )
                                      )}
                                    </td>
                                    <td
                                      className={`mt-1 pl-10 pb-20 text-wrap border-right ${isMobile ? "form-control-mobile" : ""
                                        }`}
                                    >
                                      {item.ptE2AnswerId ? (
                                        <>
                                          {this.state.pteAnswersOption?.map(
                                            (pteOption, index) => (
                                              <>
                                                <input
                                                  className={`height ${pteOption?.id ===
                                                    item?.ptE2AnswerId &&
                                                    "color-black"
                                                    }`}
                                                  type="radio"
                                                  // name={"test" + index}
                                                  disabled={
                                                    pteOption?.id !==
                                                    item?.ptE2AnswerId
                                                  }
                                                  checked={
                                                    pteOption?.id ===
                                                    item?.ptE2AnswerId
                                                  }
                                                />
                                                <label
                                                  className={`${isMobile ? "pl-3" : "pl-10"
                                                    }`}
                                                >
                                                  {pteOption?.name}
                                                </label>
                                                <br />
                                              </>
                                            )
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          {Math.round(
                                            this.state.PTE?.length / 2
                                          ) ===
                                            index + 1 && (
                                              <label className="text-color-red">
                                                PTE 2 is not submitted for this
                                                training.
                                              </label>
                                            )}
                                        </>
                                      )}
                                    </td>
                                    <td
                                      className={`mt-1 pl-10 pb-20 text-wrap border-right ${isMobile ? "form-control-mobile" : ""
                                        }`}
                                    >
                                      {item.ptE3AnswerId ? (
                                        <>
                                          {this.state.pteAnswersOption?.map(
                                            (pteOption, index) => (
                                              <>
                                                <input
                                                  className={`height ${pteOption?.id ===
                                                    item?.ptE3AnswerId &&
                                                    "color-black"
                                                    }`}
                                                  type="radio"
                                                  // name={"test" + index}
                                                  disabled={
                                                    pteOption?.id !==
                                                    item?.ptE3AnswerId
                                                  }
                                                  checked={
                                                    pteOption?.id ===
                                                    item?.ptE3AnswerId
                                                  }
                                                />
                                                <label
                                                  className={`${isMobile ? "pl-3" : "pl-10"
                                                    }`}
                                                >
                                                  {pteOption?.name}
                                                </label>
                                                <br />
                                              </>
                                            )
                                          )}
                                        </>
                                      ) : (
                                        <>
                                          {Math.round(
                                            this.state.PTE?.length / 2
                                          ) ===
                                            index + 1 && (
                                              <label className="text-color-red">
                                                PTE 3 is not submitted for this
                                                training.
                                              </label>
                                            )}
                                        </>
                                      )}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td className="border-right border-left"></td>
                                  <td
                                    colSpan={7}
                                    className="table-nodata text-center border-right p-2"
                                  >
                                    {"No record found"}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div
                        className={`col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-2 ${iswebMobile ? "mt-2" : isMobile ? "" : ""
                          } `}
                      >
                        <button
                          className={`pte-label-button label-text ${isMobile ? "pt-2" : ""
                            }`}
                        >
                          <CommonIcon fileName="jobIcon" />
                          <span className="pl-5 properties-span-2">
                            List of Job/Task/Activity Undertake After Completing
                            Training
                          </span>
                        </button>
                      </div>

                      <div className={` mt-2 ${isMobile ? "" : "pb-3"}`}>
                        <div
                          className={`table-responsive table-responsive-scroll mt-20`}
                        >
                          <table className="pte-table-width text-12-normal-400">
                            <thead>
                              <tr className="border-top height-course">
                                <th className=" skill-slno text-12-bold border-right border-left pl-5px">
                                  S.no
                                </th>
                                <th className="skill-box text-12-bold border-right border-left pl-5px">
                                  Job / Task / Activity
                                </th>
                                <th className="levelofskill text-12-bold  border-left pl-5px">
                                  Status
                                  <br></br>
                                  (Pre-Training)
                                </th>
                                <th className="levelofskill text-12-bold  border-left pl-5px">
                                  Status
                                  <br></br>
                                  (Post-Training)
                                </th>
                                <th className="levelofskill text-12-bold border-right border-left pl-5px">
                                  Status
                                  <br></br>
                                  (Post-Training-further)
                                </th>
                              </tr>
                            </thead>
                            <tbody className="border-bottom">
                              {this.state.pteJob?.length > 0 ? (
                                this.state.pteJob?.map((item, index) => (
                                  <tr
                                    key={index + "PTEJOB"}
                                    className={`${this.state.pteJob?.length !== index + 1 &&
                                      "border-bottom"
                                      } `}
                                  >
                                    <td className="mt-1 text-12-bold border-right border-left pl-10 pb-50">
                                      {index + 1}
                                    </td>
                                    <td className="mt-2 border-right border-left pl-10 pr-10 pb-20">
                                      <textarea
                                        className={`text-wrap form-text-box3 border-none resize-none border-radius-0 border-none color-white w-100 `}
                                        rows="3"
                                        value={item.question}
                                        // readOnly = {this.state.isPteSubmit}
                                        disabled={true}
                                      >
                                        {item.question}
                                      </textarea>
                                    </td>
                                    <td
                                      className={`mt-1 pl-10 pb-20 text-wrap border-right ${isMobile ? "form-control-mobile" : ""
                                        }`}
                                    >
                                      {this.state.pteJobAnswerOption?.map(
                                        (pteJobOption) => (
                                          <>
                                            <input
                                              className={`height ${pteJobOption?.id ===
                                                item?.ptE1AnswerId &&
                                                "color-black"
                                                }`}
                                              type="radio"
                                              // name={"test" + index}
                                              disabled={
                                                pteJobOption?.id !==
                                                item?.ptE1AnswerId
                                              }
                                              checked={
                                                pteJobOption?.id ===
                                                item?.ptE1AnswerId
                                              }
                                            />
                                            <label
                                              className={`${isMobile ? "pl-3" : "pl-10"
                                                }`}
                                            >
                                              {pteJobOption?.name}
                                            </label>
                                            <br />
                                          </>
                                        )
                                      )}
                                    </td>
                                    <td
                                      className={`mt-1 pl-10 pb-20 text-wrap border-right ${isMobile ? "form-control-mobile" : ""
                                        }`}
                                    >
                                      {item.ptE2AnswerId ? (
                                        <>
                                          {this.state.pteJobAnswerOption?.map(
                                            (pteJobOption) => (
                                              <>
                                                <input
                                                  className={`height ${pteJobOption?.id ===
                                                    item?.ptE2AnswerId &&
                                                    "color-black"
                                                    }`}
                                                  type="radio"
                                                  // name={"test" + index}
                                                  disabled={
                                                    pteJobOption?.id !==
                                                    item?.ptE2AnswerId
                                                  }
                                                  checked={
                                                    pteJobOption?.id ===
                                                    item?.ptE2AnswerId
                                                  }
                                                />
                                                <label
                                                  className={`${isMobile ? "pl-3" : "pl-10"
                                                    }`}
                                                >
                                                  {pteJobOption?.name}
                                                </label>
                                                <br />
                                              </>
                                            )
                                          )}{" "}
                                        </>
                                      ) : (
                                        <>
                                          {Math.round(
                                            this.state.pteJob?.length / 2
                                          ) ===
                                            index + 1 && (
                                              <label className="text-color-red">
                                                PTE 2 is not submitted for this
                                                training.
                                              </label>
                                            )}
                                        </>
                                      )}
                                    </td>
                                    <td
                                      className={`mt-1 pl-10 pb-20 text-wrap border-right ${isMobile ? "form-control-mobile" : ""
                                        }`}
                                    >
                                      {item.ptE3AnswerId ? (
                                        <>
                                          {this.state.pteJobAnswerOption?.map(
                                            (pteJobOption) => (
                                              <>
                                                <input
                                                  className={`height ${pteJobOption?.id ===
                                                    item?.ptE3AnswerId &&
                                                    "color-black"
                                                    }`}
                                                  type="radio"
                                                  // name={"test" + index}
                                                  disabled={
                                                    pteJobOption?.id !==
                                                    item?.ptE3AnswerId
                                                  }
                                                  checked={
                                                    pteJobOption?.id ===
                                                    item?.ptE3AnswerId
                                                  }
                                                />
                                                <label
                                                  className={`${isMobile ? "pl-3" : "pl-10"
                                                    }`}
                                                >
                                                  {pteJobOption?.name}
                                                </label>
                                                <br />
                                              </>
                                            )
                                          )}{" "}
                                        </>
                                      ) : (
                                        <>
                                          {Math.round(
                                            this.state.pteJob?.length / 2
                                          ) ===
                                            index + 1 && (
                                              <label className="text-color-red">
                                                PTE 3 is not submitted for this
                                                training.
                                              </label>
                                            )}
                                        </>
                                      )}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td className="border-right border-left"></td>
                                  <td className="table-nodata text-center border-right border-left p-2">
                                    No record found
                                  </td>
                                  <td></td>
                                  <td className="border-right"></td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <>
                        <div className="text-center mt-3">
                          <label className="text-16-normal fw-bold text-color-red">
                            {this.state.teamtrainingView.pteStatus?.toLowerCase() ===
                              "pte not applicable"
                              ? "PTE is not applicable for this training."
                              : "PTE is not submitted for this training."}
                          </label>
                        </div>
                      </>
                    </>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* <div
                    className="offcanvas offcanvas-end offcanvasStyle"
                    tabIndex={-1}
                    data-bs-scroll="false"
                    data-bs-backdrop="false"
                    id="propertiesScreen"
                    aria-labelledby="offcanvasScrollingLabel">
                    <div
                        className={`offcanvas-header px-4 pt-4 ${isMobile ? "pb-2" : "pb-3"}`}>
                        <h6 id="offcanvasRightLabel" className="modal-title fw-600">
                            {this.state.trainingStatus}
                        </h6>
                        <button
                            className={`text-reset offcavasclose buttonstyle ${isMobile ? "pr-0" : ""}`} style={{ backgroundColor: "white" }} onClick={() => this.closeProperties()}>
                            <CommonIcon fileName="CrossIcon" className="cursor-pointer app-image-hover" />
                        </button>
                    </div>

                    <div className="offcanvas-body px-4 pt-0">
                        <div className="row">
                            <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}>
                                <div className="form-group">
                                    <label
                                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                        <CommonIcon fileName="RequestIcon" className="properties-img" />
                                        <span className="pl-10 properties-span">Request ID</span>
                                        &nbsp;
                                    </label>
                                    <label
                                        className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"}`}>
                                        {teamtrainingView.id ? teamtrainingView.trainingRequestId : " - "}
                                    </label>
                                </div>
                            </div>
                            <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}>
                                <div className="form-group">
                                    <label
                                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                        <CommonIcon fileName="UserIcon" className="properties-img" />
                                        <span className="pl-10 properties-span">Employee name</span>
                                        &nbsp;
                                    </label>
                                    <label
                                        className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"}`}>
                                        {teamtrainingView.employeeName ? teamtrainingView.employeeName : " - "}
                                    </label>
                                </div>
                            </div>
                            <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}>
                                <div className="form-group">
                                    <label
                                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                        <CommonIcon fileName="employeecode" className="properties-img" />
                                        <span className="pl-10 properties-span">Employee code</span>
                                        &nbsp;
                                    </label>
                                    <label
                                        className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"}`}>
                                        {teamtrainingView.employeeCode ? teamtrainingView.employeeCode : " - "}
                                    </label>
                                </div>
                            </div>

                            <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}>
                                <div className="form-group">
                                    <label
                                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                        <CommonIcon fileName="CourseCodeIcon" className="properties-img" />
                                        <span className="pl-10 properties-span">Course code</span>
                                    </label>
                                    <label
                                        className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"}`}>
                                        {teamtrainingView.courseCode ? teamtrainingView.courseCode : " - "}
                                    </label>
                                </div>
                            </div>
                            <div
                                className={`col-12 col-sm-6 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"} `}>
                                <div className="form-group">
                                    <label
                                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                        <CommonIcon fileName="CourseTitleIcon" className="properties-img" />
                                        <span className="pl-7 properties-span">Course title</span>
                                    </label>
                                    <label
                                        className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"}`}>
                                        {teamtrainingView.courseTitle ? teamtrainingView.courseTitle : " - "}
                                    </label>
                                </div>
                            </div>
                            <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"}`}>
                                <div className="form-group">
                                    <label
                                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                        <CommonIcon fileName="requestedby" className="properties-img" />
                                        <span className="pl-7 properties-span"> Requested by </span>
                                    </label>
                                    <label
                                        className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"}`}>
                                        {teamtrainingView.requestedBy ? teamtrainingView.requestedBy : " - "}
                                    </label>
                                </div>
                            </div>

                            <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"} `}>
                                <div className="form-group">
                                    <label
                                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                        <CommonIcon fileName="PropertiesIcon" className="properties-img" />
                                        <span className="pl-10 properties-span">Current status</span>
                                    </label>
                                    <label
                                        className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"}`}>
                                        {teamtrainingView.currentStatus ? teamtrainingView.currentStatus : " - "}
                                    </label>
                                </div>
                            </div>

                            <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"} `}>
                                <div className="form-group">
                                    <label
                                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                        <CommonIcon fileName="DateIcon" className="properties-img" />
                                        <span className="pl-10 properties-span">
                                            Requested date
                                        </span>
                                    </label>
                                    <label
                                        className={`properties-label ${isSmallMobile ? "mt-3 mb-2" : "mt-2"}`}>
                                        {teamtrainingView.requestedDate ? moment(teamtrainingView.requestedDate).format("DD-MMM-YYYY HH:MM A") : " - "}
                                    </label>
                                </div>
                            </div>

                            {this.state.trainingtrainingBondId ?
                                <>
                                    <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"} `}>
                                        <div className="form-group">
                                            <label
                                                className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                                <CommonIcon fileName="trainingbondicon" className="properties-i mg" />
                                                <span className="pl-10 properties-span">Training bond</span>
                                            </label>
                                            <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                                <a className={`cursor-pointer text-decoration-none url-label-style d-flex ${isSmallMobile ? "mt-3 mb-2" : "mt-2"}`} onClick={() => this.handleFileOpen(this.state.trainingtrainingBondId, "url")} target="_blank">
                                                    <FileIcon fileName={this.state.trainingtrainingBond} className="documentFile" />
                                                    <span className="pl-7 text-center urlspan">{this.state.trainingtrainingBond ? this.state.trainingtrainingBond : "-"}</span>
                                                </a>
                                            </label>
                                        </div>
                                    </div>
                                </> : <></>
                            }

                            {this.state.trainingcertificateId ?
                                <>
                                    <div className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"} `}>
                                        <div className="form-group">
                                            <label
                                                className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                                <CommonIcon fileName="trainingbondicon" className="properties-img" />
                                                <span className="pl-10 properties-span">Certificate</span>
                                            </label>
                                            <label className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""}`}>
                                                <a className={`cursor-pointer text-decoration-none url-label-style d-flex ${isSmallMobile ? "mt-3 mb-2" : "mt-2"}`} onClick={() => this.handleFileOpen(this.state.trainingcertificateId, "url")} target="_blank">
                                                    <FileIcon fileName={this.state.trainingcertificate} className="documentFile" />
                                                    <span className="pl-7 text-center urlspan">{this.state.trainingcertificate ? this.state.trainingcertificate : "-"}</span>
                                                </a>
                                            </label>
                                        </div>
                                    </div>
                                </> : ""
                            }

                            
                        </div>
                        <div className="row mt-1">
                            <div className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2`}>
                                <div className="form-group">
                                    <label
                                        className={`d-flex m-0 label-text ${isMobile ? "pt-2" : ""
                                            }`}>
                                        <CommonIcon fileName="VersionIcon" className="properties-img" />
                                        <span className="pl-10 properties-span">History log</span>
                                    </label>
                                    <div className="table-responsive table-responsive-scroll mb-4 mt-3">
                                        <table id="historyTable">
                                            <tbody>
                                                {historyLogList.length !== 0 ?
                                                    historyLogList.map((i, index) => (
                                                        <>
                                                            <tr id={index} key={index}>
                                                                <th className="title-width text-12-bold">{i.status}</th>
                                                                <td className={`history-date ${isRadioMobile ? "date-width" : ""}`} >
                                                                    {i.createdDate ? moment(new Date(Date.parse(i.createdDate))).format("DD-MMM-YYYY h:mm A") : ""}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th colSpan={2} className="text-12-bold">  {i.reviewer}</th>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan={2} className="history-comment">
                                                                    {i.comments}
                                                                </td>
                                                            </tr>
                                                        </>
                                                    )) :
                                                    <tr>
                                                        <td className="table-noversion" colSpan={3}>
                                                            No history log to display
                                                        </td>
                                                    </tr>}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}

        <div
          className={` viewbar-search viewbarOpen display-hide`}
          id="searchScreen"
        >
          <div className="viewMain">
            <div className="viewTitle mb-2 px-4 pt-4">
              <h6 id="offcanvasRightLabel" className="modal-title fw-600">
                Search
              </h6>
              <button
                className={`text-reset offcavasclose buttonstyle ${isMobile ? "pr-0" : "pr-0"
                  }`}
                onClick={() => this.closeSearch()}
              >
                <CommonIcon fileName="CrossIcon" />
              </button>{" "}
            </div>

            <div className="px-4 pt-0">
              <div className="row">
                <div
                  className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                    }`}
                >
                  <div className="form-group">
                    <label
                      className={`d-flex mb-1 label-text ${isMobile ? "pt-2" : ""
                        }`}
                    >
                      <CommonIcon fileName="requestId" />
                      <span className="pl-5 properties-span-2">Request ID</span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-text-box-search  records-editinput-class "
                      value={this.state.searchInputData.trainingRequestId}
                      onChange={(e) =>
                        this.handleInputchange(e, "trainingRequestId")
                      }
                      required
                    />
                  </div>
                </div>

                <div
                  className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                    }`}
                >
                  <div className="form-group">
                    <label
                      className={`d-flex mb-1 label-text ${isMobile ? "pt-2" : ""
                        }`}
                    >
                      <CommonIcon fileName="VendorNameIcon" />
                      <span className="pl-5 properties-span-2 ">
                        Employee code
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-text-box-search  records-editinput-class"
                      value={this.state.searchInputData.employeeCode}
                      onChange={(e) =>
                        this.handleInputchange(e, "employeeCode")
                      }
                      required
                    />
                  </div>
                </div>

                <div
                  className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                    } `}
                >
                  <div className="form-group">
                    <label
                      className={`d-flex mb-1 label-text ${isMobile ? "pt-2" : ""
                        }`}
                    >
                      <CommonIcon fileName="ContactPersonIcon" />
                      <span className="pl-7 properties-span-2">
                        Employee name
                      </span>
                    </label>
                    <Select
                      className={`form-text-box-search ${this.state.employeeNameEmpty && "border-red"
                        }  `}
                      classNamePrefix="assigngroups"
                      placeholder="Please select an option"
                      styles={styles}
                      menuPosition="fixed"
                      menuPlacement="auto"
                      value={this.state.selectEmployeeName}
                      options={this.state.employeeNameList}
                      defaultValue={this.state.selectEmployeeName || "Select"}
                      isClearable={true}
                      isMulti={false}
                      isSearchable={true}
                      onChange={(e) =>
                        this.onchangeEmployeeName(e, "employeeName")
                      }
                    />
                  </div>
                </div>
                <div
                  className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                    }`}
                >
                  <div className="form-group">
                    <label
                      className={`d-flex mb-1 label-text ${isMobile ? "pt-2" : ""
                        }`}
                    >
                      <CommonIcon fileName="CourseCodeIcon" />
                      <span className="pl-5 properties-span-2">
                        Course code
                      </span>
                    </label>
                    <input
                      type="text"
                      className="form-control form-text-box-search  records-editinput-class"
                      value={this.state.searchInputData.courseCode}
                      onChange={(e) => this.handleInputchange(e, "courseCode")}
                      required
                    />
                  </div>
                </div>
                <div
                  className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-2 ${isMobile ? "" : "pb-3"
                    }`}
                >
                  <div className="form-group">
                    <label
                      className={`d-flex label-text mb-1 ${isMobile ? "pt-2" : ""
                        }`}
                    >
                      <CommonIcon fileName="CourseTitleIcon" />
                      <span className="pl-5 properties-span-2">
                        Course title
                      </span>
                    </label>
                    <input
                      type="text"
                      className={`form-control form-text-box-search  records-editinput-class`}
                      value={this.state.searchInputData.courseTitle}
                      onChange={(e) => this.handleInputchange(e, "courseTitle")}
                      required
                    />
                  </div>
                </div>

                <div
                  className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6  ${isRadioMobile ? "mt-3" : "mt-2"
                    } ${isMobile ? "" : "pb-3"}`}
                >
                  <div className="form-group">
                    <label
                      className={`d-flex label-text mb-2 ${isMobile ? "pt-2" : ""
                        }`}
                    >
                      <CommonIcon fileName="DateIcon" />
                      <span className="pl-5 properties-span-2">Start date</span>
                    </label>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        autoOk
                        variant="inline"
                        inputVariant="outlined"
                        className="form-control f-12 records-editinput-class search-date"
                        emptyLabel="dd-mmm-yyyy"
                        keyboardIcon={<CommonIcon fileName="calenderDate" />}
                        format="dd-MMM-yyyy"
                        value={
                          this.state.searchInputData.startDate
                            ? this.state.searchInputData.startDate
                            : null
                        }
                        size="small"
                        onChange={(e) => this.handleInputchange(e, "startDate")}
                        inputProps={{
                          readOnly: true,
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                </div>

                <div
                  className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6  ${isRadioMobile ? "mt-3" : "mt-2"
                    } ${isMobile ? "" : "pb-3"}`}
                >
                  <div className="form-group">
                    <label
                      className={`d-flex label-text mb-2 ${isMobile ? "pt-2" : ""
                        }`}
                    >
                      <CommonIcon fileName="DateIcon" />
                      <span className="pl-5 properties-span-2">End date</span>
                    </label>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        autoOk
                        variant="inline"
                        inputVariant="outlined"
                        className="form-control f-12 records-editinput-class search-date"
                        emptyLabel="dd-mmm-yyyy"
                        keyboardIcon={<CommonIcon fileName="calenderDate" />}
                        format="dd-MMM-yyyy"
                        value={
                          this.state.searchInputData.endDate
                            ? this.state.searchInputData.endDate
                            : null
                        }
                        size="small"
                        onChange={(e) => this.handleInputchange(e, "endDate")}
                        inputProps={{
                          readOnly: true,
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                </div>

                <div
                  className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6  ${isRadioMobile ? "mt-3" : "mt-2"
                    } ${isMobile ? "" : "pb-3"}`}
                >
                  <div className="form-group">
                    <label
                      className={`d-flex label-text mb-2 ${isMobile ? "pt-2" : ""
                        }`}
                    >
                      <CommonIcon fileName="DateIcon" />
                      <span className="pl-5 properties-span-2">
                        Requested date
                      </span>
                    </label>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        autoOk
                        variant="inline"
                        inputVariant="outlined"
                        className="form-control f-12 records-editinput-class search-date"
                        emptyLabel="dd-mmm-yyyy"
                        keyboardIcon={<CommonIcon fileName="calenderDate" />}
                        format="dd-MMM-yyyy"
                        value={
                          this.state.searchInputData.requestedDate
                            ? this.state.searchInputData.requestedDate
                            : null
                        }
                        size="small"
                        onChange={(e) =>
                          this.handleInputchange(e, "requestedDate")
                        }
                        inputProps={{
                          readOnly: true,
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </div>
                </div>
                <div
                  className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isRadioMobile ? "mt-3" : "mt-2"
                    } ${isMobile ? "" : "pb-3"}`}
                >
                  <div className="form-group">
                    <label
                      className={`d-flex mb-1 label-text ${isMobile ? "pt-2" : ""
                        }`}
                    >
                      <CommonIcon fileName="PropertiesIcon" />
                      <span className="pl-5 properties-span-2">
                        Current status
                      </span>
                    </label>
                    {/* <input type="text" className={`form-control form-text-box-search  records-editinput-class`} value={this.state.searchInputData.currentStatus} onChange={(e) => this.handleInputchange(e, "currentStatus")} required /> */}
                    <Select
                      className={`form-text-box-search`}
                      classNamePrefix="assigngroups"
                      value={this.state.currentStatus}
                      menuPosition="fixed"
                      menuPlacement="auto"
                      placeholder="Please select an option"
                      styles={styles}
                      options={this.state.currentStatusList}
                      defaultValue={this.state.currentStatus || "Select"}
                      isClearable={true}
                      isMulti={false}
                      isSearchable={true}
                      onChange={(e) => this.handleCurrentStatus(e)}
                    />
                  </div>
                </div>
                <div
                  className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isRadioMobile ? "mt-3" : "mt-2"
                    } ${isMobile ? "" : "pb-3"}`}
                >
                  <div className="form-group">
                    <label
                      className={`d-flex mb-1 label-text ${isMobile ? "pt-2" : ""
                        }`}
                    >
                      <CommonIcon fileName="trainingbondicon" />
                      <span className="pl-5 properties-span-2">
                        Training bond status
                      </span>
                    </label>
                    {/* <input type="text" className={`form-control form-text-box-search  records-editinput-class`} value={this.state.searchInputData.trainingBondStatus} onChange={(e) => this.handleInputchange(e, "trainingBondStatus")} required /> */}
                    <Select
                      className={`form-text-box-search`}
                      classNamePrefix="assigngroups"
                      value={this.state.trainingBondStatus}
                      placeholder="Please select an option"
                      styles={styles}
                      menuPosition="fixed"
                      menuPlacement="auto"
                      options={this.state.trainingBondstatusList}
                      defaultValue={this.state.trainingBondStatus || "Select"}
                      isClearable={true}
                      isMulti={false}
                      isSearchable={true}
                      onChange={(e) => this.onchangeTbStatus(e)}
                    />
                  </div>
                </div>

                <div
                  className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isRadioMobile ? "mt-3" : "mt-2"
                    } ${isMobile ? "" : "pb-3"}`}
                >
                  <div className="form-group">
                    <label
                      className={`d-flex mb-1 label-text ${isMobile ? "pt-2" : ""
                        }`}
                    >
                      <CommonIcon fileName="certificateCourseCatalogue" />
                      <span className="pl-5 properties-span-2">
                        Certificate status
                      </span>
                    </label>
                    {/* <input type="text" className={`form-control form-text-box-search  records-editinput-class`} value={this.state.searchInputData.certificateStatus} onChange={(e) => this.handleInputchange(e, "certificateStatus")} required /> */}
                    <Select
                      className={`form-text-box-search`}
                      classNamePrefix="assigngroups"
                      value={this.state.certificateStatus}
                      placeholder="Please select an option"
                      styles={styles}
                      menuPosition="fixed"
                      menuPlacement="auto"
                      options={this.state.certificateStatusList}
                      defaultValue={this.state.certificateStatus || "Select"}
                      isClearable={true}
                      isMulti={false}
                      isSearchable={true}
                      onChange={(e) => this.onchangeCertificateStatus(e)}
                    />
                  </div>
                </div>

                <div
                  className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isRadioMobile ? "mt-3" : "mt-2"
                    } ${isMobile ? "" : "pb-3"}`}
                >
                  <div className="form-group">
                    <label
                      className={`d-flex mb-1 label-text ${isMobile ? "pt-2" : ""
                        }`}
                    >
                      <CommonIcon fileName="louicon" />
                      <span className="pl-5 properties-span-2">LOU status</span>
                    </label>
                    {/* <input type="text" className={`form-control form-text-box-search  records-editinput-class`} value={this.state.searchInputData.louStatus} onChange={(e) => this.handleInputchange(e, "louStatus")} required /> */}
                    <Select
                      className={`form-text-box-search`}
                      classNamePrefix="assigngroups"
                      value={this.state.louStatus}
                      placeholder="Please select an option"
                      styles={styles}
                      menuPosition="fixed"
                      menuPlacement="auto"
                      options={this.state.louStatusList}
                      defaultValue={this.state.louStatus || "Select"}
                      isClearable={true}
                      isMulti={false}
                      isSearchable={true}
                      onChange={(e) => this.onchangeLouStatus(e)}
                    />
                  </div>
                </div>

                <div
                  className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isRadioMobile ? "mt-3" : "mt-2"
                    } ${isMobile ? "" : "pb-3"}`}
                >
                  <div className="form-group">
                    <label
                      className={`d-flex mb-1 label-text ${isMobile ? "pt-2" : ""
                        }`}
                    >
                      <CommonIcon fileName="CourseQuestionIcon" />
                      <span className="pl-5 properties-span-2">CQ status</span>
                    </label>
                    {/* <input type="text" className={`form-control form-text-box-search  records-editinput-class`} value={this.state.searchInputData.courseQuestionnaireStatus} onChange={(e) => this.handleInputchange(e, "courseQuestionnaireStatus")} required /> */}
                    <Select
                      className={`form-text-box-search`}
                      classNamePrefix="assigngroups"
                      value={this.state.courseQuestionnaireStatus}
                      placeholder="Please select an option"
                      styles={styles}
                      menuPosition="fixed"
                      menuPlacement="auto"
                      options={this.state.cqStatusList}
                      defaultValue={
                        this.state.courseQuestionnaireStatus || "Select"
                      }
                      isClearable={true}
                      isMulti={false}
                      isSearchable={true}
                      onChange={(e) => this.onchangeCqStatus(e)}
                    />
                  </div>
                </div>

                <div
                  className={`col-12 col-sm-12 col-lg-6 col-xl-6 col-md-6 ${isRadioMobile ? "mt-3" : "mt-2"
                    } ${isMobile ? "" : "pb-3"}`}
                >
                  <div className="form-group">
                    <label
                      className={`d-flex mb-1 label-text ${isMobile ? "pt-2" : ""
                        }`}
                    >
                      <CommonIcon fileName="pteIcon" />
                      <span className="pl-5 properties-span-2">PTE status</span>
                    </label>
                    {/* <input type="text" className={`form-control form-text-box-search  records-editinput-class`} value={this.state.searchInputData.pteStatus} onChange={(e) => this.handleInputchange(e, "pteStatus")} required /> */}
                    <Select
                      className={`form-text-box-search`}
                      classNamePrefix="assigngroups"
                      value={this.state.pteStatus}
                      placeholder="Please select an option"
                      styles={styles}
                      menuPosition="fixed"
                      menuPlacement="auto"
                      options={this.state.pteStatusList}
                      defaultValue={this.state.pteStatus || "Select"}
                      isClearable={true}
                      isMulti={false}
                      isSearchable={true}
                      onChange={(e) => this.onchangePteStatus(e)}
                    />
                  </div>
                </div>
              </div>

              {this.state.validationMsg ? (
                <span className="properties-span-2 text-danger">
                  Atleast one field is mandatory
                </span>
              ) : (
                ""
              )}

              <div className="d-flex mt-20">
                <button
                  className={`btn rejectbutton d-flex gap-1`}
                  onClick={() => this.clearSearchDetails()}
                >
                  <span className="mt-0">
                    <CommonIcon fileName="clearIcon1" />
                  </span>
                  <span className="pl-vendor3 pl-2">Clear</span>
                </button>
                <button
                  className={`btn approvebutton ml-10 d-flex gap-1`}
                  onClick={() => this.validateSearchRecords()}
                >
                  <span className="">
                    <CommonIcon fileName="searchableIcon" />
                  </span>
                  <span className="model-label pl-vendor3 pl-2">Search</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Modal - Warning */}

        <WarningComponent
          message={
            this.state.action === "cancel"
              ? "Are you sure you want to cancel the request?"
              : "Are you sure you want to reject the request?"
          }
          isMobile={this.state.isMobile}
          onYesClick={
            this.state.action === "cancel"
              ? this.handleCancelRequestPopup
              : this.handleRejectPopup
          }
        />

        <PaginationComponent
          fetchPagination={this.fetchPaginationList}
          pageCount={this.state.totalCount}
          reset={this.state.pageNewCount}
        />
      </>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

function mapStateToProps(state) {
  return {
    menuToggle: state.commonReducer.menuToggle,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Training)
);
